import React, { FC, lazy, Suspense, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";

import { AppUserApi } from "../../api";
import { useAppSelector } from "../../redux-config/hooks";
import { selectUser } from "../../redux-config/entities/user";
import { FoodLogType, PaginationType } from "../../DTO";
import { CustomPagination } from "../pagination";
import { useAppNavigate } from "../../Router/hook";
import { FoodLogTable } from "./food_log_table";
import { Loading } from "../loading";
const FoodLogDetailsModal = lazy(() => import("./food_log_details_modal"));

export const FoodLog: FC<{ userId: number; currentDate: string }> = ({
    userId,
    currentDate,
}) => {
    const [loader, setLoader] = useState<boolean>(false);
    const [foodLog, setFoodLog] = useState<FoodLogType[]>([]);
    const [pagination, setPagination] = useState<PaginationType>({
        current_page: 1,
        per_page: 10,
        total: 0,
    });
    const [selectedFood, setSelectedFood] = useState<FoodLogType | null>(null);
    const [showModal, setShowModal] = useState(false);

    const user = useAppSelector(selectUser);
    const navigate = useAppNavigate();

    const fetchFoodLogList = (pageNumber: number) => {
        setLoader(true);

        AppUserApi.FoodLogApi.FoodLogList({
            appUser: user,
            userId,
            currentPage: pageNumber,
            date: currentDate,
        })
            .then((data) => {
                setFoodLog(data.food);
                setPagination(data.pagination);
                setLoader(false);
            })
            .catch((err) => {
                setLoader(false);
                Swal.fire({
                    icon: "error",
                    text: err,
                });
            });
    };

    useEffect(() => {
        if (currentDate && userId && user?.access_token) {
            fetchFoodLogList(1);
        }
    }, [currentDate, userId, user]);

    const handleViewItems = (item: FoodLogType) => {
        setSelectedFood(item);
        setShowModal(true);
    };

    return (
        <>
            {loader ? (
                <div className="d-flex justify-content-center align-items-center p-5">
                    <Spinner animation="border" />
                </div>
            ) : foodLog.length > 0 ? (
                <div className="d-flex flex-column gap-3">
                    <FoodLogTable
                        items={foodLog}
                        onViewItems={handleViewItems}
                        userId={userId}
                    />

                    <div className="w-100 d-flex justify-content-center">
                        <CustomPagination
                            total={pagination.total}
                            perPage={pagination.per_page}
                            currentPage={pagination.current_page}
                            changePage={(pageNum: number) => {
                                navigate(
                                    `/app-user/${userId}/progress/report?type=food_detail&page=${pageNum}&date=${currentDate}`,
                                );

                                fetchFoodLogList(pageNum);
                            }}
                        />
                    </div>
                </div>
            ) : (
               <div className="upr-empty-state text-center">
  <div className="upr-empty-icon mb-3">
    🍽️
  </div>
  <h6 className="fw-semibold text-danger mb-1">
    No Food Logs Found
  </h6>
  <p className="text-muted small mb-0">
    There are no food entries for the selected day.
  </p>
</div>

            )}

            <Suspense fallback={<Loading />}>
                <FoodLogDetailsModal
                    food={selectedFood}
                    show={showModal}
                    onClose={() => setShowModal(false)}
                />
            </Suspense>
        </>
    );
};
